import { MenuItem } from '@szhsin/react-menu';
import { map, some } from 'lodash-es';

import MenuLink from '../MenuLink';
import { IMenuItemsContainer } from '../components/menuFactory/MenuItems';
import { isMenuItem, isSubMenu } from '../menu/MenuGenerator';
import IBaseMenuItem from '../models/IBaseMenuItem';
import IMenuItem from '../models/IMenuItem';
import ISubMenu from '../models/ISubMenu';

export const renderMenuItems = (
	menuItemsContainer: IMenuItemsContainer
): React.JSX.Element[] | null => {
	const renderChildItems = (childItems?: IBaseMenuItem[]) => {
		if (some(childItems)) {
			return map(childItems, (nestedItem) => {
				const menuItem = nestedItem as IMenuItem;
				const subMenuItem = nestedItem as ISubMenu;

				if (!isSubMenu(subMenuItem) && isMenuItem(menuItem)) {
					return (
						<MenuItem
							key={menuItem.label}
							className="menu__dropdown__list__item">
							{menuItem.label}
							{menuItem.children}
							<MenuLink url={menuItem.route} />
						</MenuItem>
					);
				} else {
					throw new Error('Sub menus are not supported.');
				}
			});
		}

		return null;
	};

	return renderChildItems(menuItemsContainer.menuItems);
};
